// extracted by mini-css-extract-plugin
export default {"parent":"formTextarea_parent__MS8OY","parentErrorInform":"formTextarea_parentErrorInform__6T24s"};